<div class="four-o-mini-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close ChatGPT 4o mini Info">
    <span aria-hidden="true"><i class="fas fa-bars"></i></span>
  </button>

  <div class="header">
    <img src="assets/metabrain.jpeg" alt="ChatGPT 4o mini Logo" class="mini-logo" />
    <h2>ChatGPT 4o </h2>
    <div class="sub">OpenAI’s Fastest, Most Affordable Multimodal Model</div>
  </div>

  <div class="body">
    <p>
      <strong>ChatGPT 4o </strong> brings you the power of OpenAI’s new flagship “omni” model—now lighter, faster, and optimized for high-volume, real-time applications. This model excels at natural, context-aware conversation and can handle text, images, and audio prompts (where supported).
    </p>

    <ul>
      <li>⚡ <strong>Lightning Fast:</strong> Delivers near-instant replies, even under heavy load.</li>
      <li>💸 <strong>Ultra Affordable:</strong> Ideal for startups, prototypes, and projects with lots of usage.</li>
      <li>🗣️ <strong>Rich Conversational Abilities:</strong> Handles complex context, follows instructions, and adapts tone naturally.</li>
      <li>🔗 <strong>Multimodal (Beta):</strong> Ready for text, image, and audio input with broad support in the OpenAI ecosystem.</li>
      <li>🔒 <strong>Backed by OpenAI’s Safety:</strong> Maintains strong moderation and ethical alignment out of the box.</li>
    </ul>

    <div class="optimal">
      <h3>When is ChatGPT 4o optimal?</h3>
      <ul>
        <li>✔️ When you want to serve thousands or millions of users affordably</li>
        <li>✔️ For chatbots and virtual agents requiring fast, humanlike dialog</li>
        <li>✔️ For creative generation, summaries, and smart automation</li>
        <li>✔️ For mobile and embedded applications needing speed + efficiency</li>
        <li>✔️ Whenever you want best-in-class AI at minimal cost and latency</li>
      </ul>
    </div>
  </div>
</div>
